/* eslint-disable no-undef */

import { configureStore as createReduxStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';

import rootReducer from './reducers/index';

export default function configureStore(initialState, history) {
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history });

  const middleware = __BROWSER__ ? [routerMiddleware] : [];

  const store = createReduxStore({
    reducer: rootReducer(routerReducer),
    preloadedState: initialState,
    // thunk and immutable-state checks are included by default; the serializable
    // check is left off to match the prior store's behavior.
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    devTools: __DEV__,
  });

  return { store, history: createReduxHistory(store) };
}
